export var colors = {
  colorScheme: {
    domain: ["#c7d3ec", "#a5b8db", "#879cc4", "#677795", "#5a6782"],
    tack: '#000550',
    gybe: '#E600FF',
  }
}
